import { Injectable } from '@angular/core';

import { AggregatedStatus } from '@vi-iot/client';

import { InstallationDetailsStore } from '../installation-details/installation-details.store';
import { InstallationsStore } from '../installations/installations.store';

@Injectable({
  providedIn: 'root',
})
export class AggregatedStatusService {
  constructor(
    private installationDetailsStore: InstallationDetailsStore,
    private installationsStore: InstallationsStore
  ) {}

  liveUpdateAggregatedStatus(
    gatewaySerial: string,
    aggregatedStatus: AggregatedStatus,
    lastChangedAt: string
  ): void {
    this.installationDetailsStore.liveUpdateAggregatedStatus(
      gatewaySerial,
      aggregatedStatus,
      lastChangedAt
    );

    this.liveUpdateAggregatedStatusOverview(aggregatedStatus, lastChangedAt, gatewaySerial);
  }

  liveUpdateAggregatedStatusOverview(
    aggregatedStatus: AggregatedStatus,
    lastChangedAt: string,
    gatewaySerial: string
  ): void {
    this.installationsStore.liveUpdateAggregatedStatus(
      aggregatedStatus,
      lastChangedAt,
      gatewaySerial
    );
  }
}
